'use client';

import { useEffect } from 'react';
import { initAnalytics, trackEvent } from '../lib/analytics/posthog';
import { EVENTS } from '../lib/analytics/events';

// Par de NotFoundTracker para los errores: sin esto, un 503 por rate limit de cyclone o un error de
// render no dejaban rastro en PostHog. `initAnalytics()` porque global-error reemplaza el layout raíz
// (y con él los providers que inician PostHog); si ya estaba iniciado, no hace nada.
export default function ErrorPageTracker({ error, boundary }) {
  useEffect(() => {
    initAnalytics();
    trackEvent(EVENTS.ERROR_PAGE_VIEWED, {
      error_type: '500',
      url: window.location.href,
      referrer: document.referrer || null,
      error_name: error?.name || null,
      error_digest: error?.digest || null,
      boundary
    });
  }, [error, boundary]);

  return null;
}
